import { render, staticRenderFns } from "./CommandBaseContact.vue?vue&type=template&id=65e5787c&"
import script from "./CommandBaseContact.js?vue&type=script&lang=js&"
export * from "./CommandBaseContact.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports